export default __webpack_public_path__ + "static/media/message1.3c7f631d.svg";